<template>
  <div v-if="canVerb(resource, 'index')">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <actions-toolbar>
          <template #filters>
            <div class="status-filter">
              <div class="pill-wrapper my-3">
                <span
                  class="pill"
                  v-for="(value, name, index) in activeFilters"
                  :key="index"
                  data-color="white"
                >
                  <span v-b-toggle.sidebar-1 :data-filter="name"
                    ><strong>{{ sidebarFilterName(name, context) }}</strong
                    >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                  >
                  <span tabindex="0">
                    <span
                      @click="resetSingleSidebarFilter(name)"
                      title="Rimuovi filtro"
                      >×</span
                    >
                  </span>
                </span>
                <template v-if="countActiveFilters">
                  <span
                    class="pill"
                    data-color="alert"
                    @click="resetAllFilters()"
                    title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                  >
                    <span
                      ><strong
                        >Reset ({{ countActiveFilters }})</strong
                      ></span
                    >
                    <span><span>×</span></span>
                  </span>
                </template>
              </div>
            </div>
          </template>
          <b-button-group
            v-b-toggle.sidebar-1
            :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
              countActiveFilters ? ' active' : ''
            }`"
            :title="getDefaultFilterMessage()"
          >
            <base-icon name="filters" width="23" height="23" />
            <span style="font-size: 14px; font-weight: 500">{{
              computedFilterTitle
            }}</span>
          </b-button-group>
          <b-button
            type="button"
            variant="secondary"
            size="sm"
            class="btn--smaller btn--transparent"
            @click="onRefreshContent()"
            title="Refresh"
          >
            <base-icon name="reload" width="20" height="20" />
            Ricarica
          </b-button>
          <b-button
            class="btn-create btn--smaller"
            type="button"
            variant="primary"
            size="sm"
            @click="onAdd"
            title="Crea"
            v-if="canVerb(resource, 'store')"
          >
            <base-icon name="circled_plus" width="22" height="22" />
            Crea
          </b-button>
        </actions-toolbar>
        <div class="table-container">
          <b-sidebar
            id="sidebar-1"
            :title="computedFilterTitle"
            :backdrop="true"
            width="50dvw"
            shadow
            right
            :visible="open_filter"
            :data-open="open_filter"
            @change="onSidebarFilterChange"
          >
            <template #header="{ hide }">
              <div class="inner-header">
                <div class="inner-header--create">
                  <strong class="mr-auto"> Crea una nuova procedura </strong>
                  <b-button
                    class="btn btn--create btn--smaller"
                    type="button"
                    variant="primary"
                    size="sm"
                    @click="onAdd"
                    title="Crea una nuova procedura"
                    :disabled="!canVerb(resource, 'store')"
                  >
                    <base-icon name="circled_plus" width="16" height="16" />
                    <span>Crea</span>
                  </b-button>
                </div>
                <div class="inner-header--info">
                  <strong class="mr-auto">
                    {{ computedFilterTitle }}
                  </strong>
                  <button class="close text-dark" @click="hide">
                    <b-icon icon="x"></b-icon>
                  </button>
                </div>
              </div>
            </template>
            <b-form @submit.prevent="onSearch(filterName)">
              <div class="filter">
                <div class="filter-item">
                  <base-input
                    name="id"
                    label="ID procedura"
                    v-model="filter.byAttribute.id"
                    placeholder="Cerca per ID..."
                  />
                </div>
                <div class="filter-item">
                  <base-input
                    name="description"
                    label="Descrizione"
                    v-model="filter.byAttribute.description"
                    placeholder="Cerca per descrizione..."
                  />
                </div>
                <div class="filter-item">
                  <base-select
                    name="status"
                    label="Stato"
                    v-model="filter.byAttribute.status_procedure"
                    :options="statusOptions"
                  />
                </div>
                <div class="filter-item">
                  <base-select
                    name="communication_type"
                    label="Tipo"
                    v-model="filter.byAttribute.communication_type"
                    :options="typeOptions"
                  />
                </div>
                <div class="filter-item" data-cols="2">
                  <base-datepicker
                    vid="da"
                    name="Creazione da"
                    label="Creazione da"
                    v-model="filter.byCalendar.from"
                  />
                  <base-datepicker
                    vid="a"
                    name="Creazione a"
                    label="Creazione a"
                    v-model="filter.byCalendar.to"
                  />
                </div>
              </div>
              <div class="actions-filter-sidebar-wrapper">
                <b-button
                  type="submit"
                  variant="lisaweb"
                  size="sm"
                  v-b-toggle:sidebar-1
                  >Cerca
                </b-button>
                <b-button
                  class="btn--transparent btn-reset"
                  type="button"
                  size="sm"
                  @click="onClearFilter(filterName)"
                  >Reset
                </b-button>
              </div>
            </b-form>
          </b-sidebar>
          <communication-procedures
            @edit="onEdit"
            @destroy="onDestroy"
            @editSchedule="onEditSchedule"
            @retryFailed="onRetryFailed"
            @viewLogs="onViewLogs"
            @manualFetch="manualFetch"
            :fields="fields"
            :repository="repository"
            :resource="resource"
            :filterName="filterName"
            :performedSearch="computePerformedSearch"
            :filterCount="countActiveFilters"
            :ref="tableRef"
            :onlyActions="[
              'edit',
              'edit_schedule',
              'retry_failed',
              'view_logs',
              'destroy',
            ]"
            :filterOn="{
              byRelations: ['byDocument'],
            }"
            descending
            sortField="created_at"
            @download="downloadDocument"
          ></communication-procedures>
          <div>
            <select-option-modal
              :opts="typeOptions"
              :showNote="true"
              title="Seleziona il tipo"
              @select="onSelectOption"
            />
            <edit-schedule-modal
              :item="scheduleItem"
              @save="onSaveSchedule"
              @cancel-schedule="onCancelSchedule"
            />
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import CommunicationProcedures from "@/components/tables/CommunicationProcedures";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import SelectOptionModal from "@/components/modals/selectOption";
import EditScheduleModal from "@/components/modals/editScheduleModal";
import { RepositoryFactory as LisacomunicaRepositoryFactory } from "@/repositories/lisacomunica/RepositoryFactory";
import { mapGetters, mapActions } from "vuex";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import FormMixin from "@/mixins/FormMixin";
import ConfirmModalMixin from "@/mixins/ConfirmModalMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { toLocaleDate } from "@/utils/dates";
import { getInputType } from "@/utils/forms";
import { canSeeAllCommunications } from "@/utils/permissions";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";
import BaseInput from "../../form/BaseInput.vue";

export default {
  mixins: [
    FormMixin,
    ConfirmModalMixin,
    CustomFiltersMixin,
    DocumentsMixin,
    SidebarFilterMixin,
  ],
  data() {
    return {
      isLoading: false,
      repository: "communication_procedure",
      resource: "communication_procedures",
      context: "communication_procedures",
      filterName: "filterCommunicationProcedure",
      activeFilters: {},
      performedSearch: false,
      filter: this.initFilter(),
      form: {
        communication_procedure: {
          status_procedure: 0,
          communication_type: null,
        },
      },
      statusOptions: [
        { text: "Inizio", value: 0 },
        { text: "Esclusioni", value: 1 },
        { text: "Raggruppamenti", value: 2 },
        { text: "Modifica", value: 3 },
        { text: "Template", value: 4 },
        { text: "Invio", value: 5 },
        { text: "Schedulato", value: 6 },
        { text: "Annullato", value: 7 },
        { text: "Errore", value: 8 },
        { text: "Completato", value: 9 },
        { text: "Completato con errori", value: 10 },
      ],
      typeOptions: [
        { text: "Email", value: 0 },
        { text: "SMS", value: 2 },
        { text: "Stampa PDF", value: 3 },
      ],
      tableRef: "CommunicationProceduresTableRef",
      /* La procedura su cui la modale di schedulazione sta agendo */
      scheduleItem: null,
      fields: [
        {
          key: "id",
          label: "ID",
        },
        {
          key: "description",
          label: "Descrizione",
        },
        {
          key: "status_procedure.text",
          label: "Stato",
        },
        {
          key: "communication_type.text",
          label: "Tipo",
        },
        {
          key: "created_date",
          formatter: (value) => toLocaleDate(value, "DD/MM/YYYY HH:mm:ss"),
          label: "Data creazione",
          sortKey: "created_at",
          sortable: true,
        },
        // chi vede le procedure di tutti vede anche chi le ha create
        ...(canSeeAllCommunications()
          ? [
              {
                key: "user_id",
                label: "Utente",
                formatter: (value) =>
                  this.$store.getters["auth/users"].find(
                    (user) => user.value === value,
                  )?.username ?? "-",
              },
            ]
          : []),
        {
          key: "scheduled_at",
          formatter: (value) =>
            value ? toLocaleDate(value, "DD/MM/YYYY HH:mm") : "",
          label: "Invio programmato",
          sortable: true,
        },
        {
          key: "is_channel_excluded.text",
          label: "Esclusi per canale",
          class: "text-center",
        },
        {
          key: "is_broker_excluded.text",
          label: "Esclusi per produttore",
          class: "text-center",
        },
        {
          key: "files",
          label: "File generati",
          thStyle: {
            "min-width": "200px",
          },
        },
      ],
    };
  },
  components: {
    BaseInput,
    BaseIcon,
    BaseDatepicker,
    BaseSelect,
    CommunicationProcedures,
    SelectOptionModal,
    EditScheduleModal,
  },
  beforeMount() {
    // CustomFiltersMixin ripristina i sotto-oggetti del filtro salvato per
    // riferimento: si lavora su una copia, così le modifiche nella sidebar non
    // confermate con Cerca non finiscono nello store (Ricarica e polling)
    this.filter = JSON.parse(JSON.stringify(this.filter));
    // arrivo dai log LisaComunica: pre-filtra per ID procedura e ripulisce
    // l'URL, così il filtro resta modificabile e non si ripresenta. Il filtro
    // si salva prima del mount della tabella, che lo carica da sé
    const procedureId = this.$route.query.id;
    if (procedureId) {
      this.filter.byAttribute.id = procedureId;
      this.$router.replace({ query: {} });
      this.saveFilterByName({
        name: this.filterName,
        criteria: JSON.parse(JSON.stringify(this.filter)),
      });
      this.removePaginationByName(this.filterName);
    }
  },
  mounted() {
    if (this.isShowAutoModal) this.$bvModal.show("selectOption");
    const table = this.$refs[this.tableRef];
    if (!table) return;
    // filtri salvati (ripristinati in this.filter da CustomFiltersMixin): qui
    // si mostrano le pill
    if (this.loadFilter(this.filterName)) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      // template.vue carica da sé se la query string del filtro non è vuota;
      // altrimenti (es. admin con tutti i criteri vuoti) il fetch è qui
      if (!table.loadFilter(table.filterName)) table.fetch();
      return;
    }
    // default search on page load, con il filtro iniziale (byUser per i non admin)
    this.onSearch(this.filterName);
  },
  created() {},
  beforeDestroy() {
    this.saveLisacomunicaAutoModal(false);
    this.saveLisacomunicaFromAncillaries(false);
  },
  computed: {
    ...mapGetters("lisacomunica_automodal", [
      "isShowAutoModal",
      "isFromAncillaries",
    ]),
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    getInputType,
    initFilter() {
      let init = {
        byAttribute: {
          id: null,
          description: null,
          status_procedure: null,
          communication_type: null,
        },
        byCalendar: {
          from: null,
          to: null,
        },
        byUser: {
          // ognuno vede solo le proprie procedure; tutte gli admin e chi ha
          // il permesso di vederle
          id: canSeeAllCommunications() ? null : this.$store.state.auth.user.id,
        },
      };
      return init;
    },
    onAdd() {
      this.$bvModal.show("selectOption");
    },
    onSelectOption(val, note) {
      console.debug("onSelectOption: ", val);
      if (val != null) {
        this.isLoading = true;
        this.fetchCreateForm(this.repository).then(() => {
          this.form[this.repository].is_broker_excluded = "Y";
          this.form[this.repository].communication_type = val;
          this.form[this.repository].description = note || null;
          this.form[this.repository].status_procedure = 1;
          this.form[this.repository].is_vehicle_premium_shown = 1;
          this.form[this.repository].is_life_premium_shown = 1;
          this.form[this.repository].is_extra_vehicle_premium_shown = 1;

          const storeCall = this.isFromAncillaries
            ? RepositoryFactory.get(this.repository).store_from_ancillaries(
              this.form[this.repository],
            )
            : this.store(this.repository);
          storeCall
            .then((response) => {
              this.isLoading = false;
              this.$showSnackbar({
                preset: "success",
                text: "Procedura creata correttamente",
              });
              let procedure_id = response.data.data.id;
              this.onEdit(procedure_id, response.data.data);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
              this.isLoading = false;
            });
        });
      } else {
        this.$showSnackbar({
          preset: "info",
          text: "Selezionare il tipo",
        });
      }
    },
    onEdit(id, item) {
      // UNCOMMENT to FIX and properly set the breadcrumbs: must recreate the path
      // in pratica, se non c'è Management.vue sulla rotta, pulire e settare solo level 0
      this.emptyQueue();
      this.notifyQueue({
        level: 0,
        path: "",
        text: "Comunicazioni",
      });
      this.$router.push({
        name: "communication_procedures.edit",
        params: {
          id,
          status_procedure: item.status_procedure.value,
          communication_type: item.communication_type.value,
          category: item.category.value,
        },
      });
      console.debug("onEdit: ", id, item.status_procedure.value);
    },
    onResume(id, item) {
      console.debug("onResume: ", id, " status: ", item.status_procedure.value);
    },
    onEditSchedule(item) {
      this.scheduleItem = item;
      this.$bvModal.show("editScheduleModal");
    },
    /*
     * Sposta la schedulazione, o riprogramma un invio andato in errore.
     *
     * LisaComunica va chiamata PRIMA: è l'unica delle due a poter rifiutare
     * l'operazione (409 se l'invio è già partito), e chiamandola per prima un
     * rifiuto lascia LisaWeb intatto e non serve alcun rollback.
     */
    onSaveSchedule(scheduledAt) {
      const item = this.scheduleItem;
      if (!item) return;
      const LcRepo = LisacomunicaRepositoryFactory.get("schedule");
      const Repo = RepositoryFactory.get(this.repository);
      // Nessun isLoading qui: il template è dentro un v-if="!isLoading", quindi
      // accenderlo smonta tabella e modali e al ritorno della promise il ref
      // della tabella non esiste più. Il feedback lo danno il refresh della
      // griglia e lo snackbar, come in onDestroy.
      LcRepo.update(item.id, { scheduled_at: scheduledAt })
        .then(() =>
          Repo.schedule(item.id, {
            status_procedure: 6,
            scheduled_at: scheduledAt,
          })
        )
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Schedulazione aggiornata con successo",
          });
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    /* Annulla la schedulazione: l'observer lato backend rilascia le quietanze. */
    onCancelSchedule() {
      const item = this.scheduleItem;
      if (!item) return;
      const LcRepo = LisacomunicaRepositoryFactory.get("schedule");
      const Repo = RepositoryFactory.get(this.repository);
      LcRepo.destroy(item.id)
        .then(() => Repo.schedule(item.id, { status_procedure: 7 }))
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Schedulazione annullata con successo",
          });
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    /*
     * Ritrasmette i messaggi falliti della procedura. Il conteggio arriva da
     * LisaComunica (totalElements dei log FAILED); la ritrasmissione è
     * asincrona: LisaComunica rimette in coda i messaggi e risponde subito.
     */
    onRetryFailed(item) {
      const LogRepo = LisacomunicaRepositoryFactory.get("log");
      LogRepo.index(
        `procedure_id=${item.id}&status=FAILED&page=1&perPage=1`
      )
        .then((response) => {
          const failed = response?.data?.totalElements || 0;
          if (!failed) {
            this.$showSnackbar({
              preset: "info",
              text: "Nessun messaggio fallito da ritrasmettere",
            });
            return;
          }
          this.showConfirm({
            yesCallback: () => {
              LogRepo.retry({ procedure_id: item.id })
                .then(() => {
                  this.$showSnackbar({
                    preset: "success",
                    text: `Ritrasmissione avviata per ${failed} messaggi`,
                  });
                  // LisaComunica la riporta in Invio e la richiude a reinvio
                  // concluso: la riga si segue da subito, fino al nuovo esito
                  item.status_procedure = { value: 5, text: "Invio" };
                  item.last_update = null;
                  const table = this.$refs[this.tableRef];
                  if (table?.isPollingInProgress) table.requestPollingRestart();
                  else table?.startPolling();
                })
                .catch((error) => {
                  let errMsg =
                    error?.response?.data?.message ||
                    this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
            },
            noCallback: null,
            title: "Ritrasmetti fallite",
            message: `Verranno ritrasmessi ${failed} messaggi falliti della procedura. Continuare?`,
            yesLabel: "RITRASMETTI",
            noLabel: "ANNULLA",
          });
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    /* Apre i log LisaComunica filtrati per questa procedura */
    onViewLogs(item) {
      this.$router.push({
        name: "lisacomunica_log",
        query: { procedure_id: item.id },
      });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Procedura eliminata con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    openNoteModal(array) {
      this.notes = array;
      this.$bvModal.show("noteDetailModal");
    },
    openDocumentModal(array) {
      this.documents = array;
      this.$bvModal.show("documentDetailModal");
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["byUser.id"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      // una copia: la sidebar resta libera fino al prossimo Cerca
      let criteria = JSON.parse(JSON.stringify(this.filter));
      // store the filter
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      // fetch data
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].requestPollingRestart();
      this.$refs[this.tableRef].fetch();
    },
    onRefreshContent() {
      // ricarica la pagina corrente con filtri, ordinamento e paginazione salvati;
      // niente richieste parallele se la tabella sta già caricando
      const table = this.$refs[this.tableRef];
      if (!table || table.isLoading) return;
      table.requestPollingRestart();
      table.fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "created_at";
      this.$refs[this.tableRef].sortDesc = true;
      // this.onSearch(name);
    },
    onSelectProvince(selected) {
      this.opt_councils = this.getCouncils()(selected);
      this.filter.byCorrespondence.CITY = null;
    },
    onRemoveProvince() {
      this.opt_councils = [];
      this.filter.byCorrespondence.CITY = null;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapActions("queue", ["notifyQueue", "emptyQueue"]),
    ...mapActions("lisacomunica_automodal", [
      "saveLisacomunicaAutoModal",
      "saveLisacomunicaFromAncillaries",
    ]),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
};
</script>
